import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on main dashboard/home pages
  const hiddenPaths = ['/dashboard', '/dashboard/quick-links', '/', '/login'];
  const isHidden = hiddenPaths.includes(location.pathname);

  if (isHidden) return null;

  return (
    <button
      onClick={() => navigate(-1)}
      className={`inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 rounded-lg shadow-sm transition-all ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      Back
    </button>
  );
};

export default BackButton;
